import React from 'react';
import * as Ons from 'react-onsenui';
import Toolbar from '../Toolbar';
import HoldButton from '../Controls/HoldButton';
import { translate as _ } from '../../util/i18n';

class Supplementary extends React.Component {

    constructor( props ) {

        super( props );

        this.handleBackClick = this.handleBackClick.bind( this );
        this.handleSignClick = this.handleSignClick.bind( this );

    }

    handleBackClick() {

        this.props.onBackClick();

    }

    handleSignClick() {

        this.props.onSign();

    }

    render() {

        return (

            <Ons.Page renderToolbar={() => <Toolbar onBackClick={this.handleBackClick} onMenuClick={this.props.onMenuClick} />}>

                <Ons.Card className="supplementary">

                    <h3>{_( 'Beiblatt zu Spiel #' ) + this.props.gameName}</h3>
                    <p>{_( 'Ich bin berechtigt, für den angeführten Verein Spielberichte und Roster zu unterfertigen und bestätige mit meiner Unterschrift, dass' ) }</p>
                    <ol>
                        <li>{_( 'alle am Spiel teilnehmenden Spieler durch Eintragung ihrer Trikotnummer und Position im DP (Digital Playerpass) angeführt sind und keine anderen Spieler eingesetzt werden.' )}</li>
                        <li>{_( 'alle anwesenden aber am Spiel nicht teilnehmenden Spieler durch die Eintragung "PNP" (present not playing) im DP angeführt sind.' )}</li>
                        <li>{_( 'alle nicht anwesenden Spieler durch die Eintragung "ABSENT" im DP angeführt sind.' )}</li>
                        <li>{_( 'alle Angaben überprüft wurden, vollständig und richtig sind.' )}</li>
                        <li>{_( 'alle Spieler über die IFAF-Football-Regel 1-4-4 (vorgeschriebene Ausrüstung) sowie die Regel 1-4-7 (verbotene Ausrüstung) informiert wurden. Die Spieler wurden auch darüber unterrichtet, wie die Ausrüstung zu tragen ist und dass sie verpflichtet sind, während des Spieles verboten gewordene Ausrüstungen bzw. deren Teile umgehend dem Coaching Staff zu melden.' )}</li>
                        <li>{_( 'alle Spieler über die Anti-Doping Bestimmungen informiert wurden.' )}</li>
                        <li>{_( 'die Schiedsrichter keine wie immer geartete Haftung tragen und in jedem Fall schad- und klaglos gehalten werden.' )}</li>
                    </ol>

                    <HoldButton label={_( 'Halten zum Unterschreiben' )} onClick={this.handleSignClick} disabled={this.props.loading} />

                </Ons.Card>

            </Ons.Page>

        );

    }

}

export default Supplementary;